export default __webpack_public_path__ + "static/media/LogoBhawana.d9d77cba.png";